import { useMaasOidcAccessToken } from '@maas-tools/auth-oidc'
import { Navigate, Outlet } from 'react-router-dom'
import { ERoutes } from 'common/entities/routes'
import AppLoading from 'containers/AppLoading/AppLoading'
import MigrationGuard from 'containers/MigrationGuard'
import { PageView } from 'containers/PageView'
import SessionReliabilityGuard from 'containers/SessionReliabilityGuard'
import PrivateRouteLayout from '../PrivateRouteLayout'
import { ProtectedPageProviders } from './ProtectedPageProviders'

export const ProtectedPageShell = () => {
  const { accessToken } = useMaasOidcAccessToken()
  if (!accessToken) {
    return <Navigate to={ERoutes.ID_MAGALU_PRELOGIN} replace />
  }

  return (
    <SessionReliabilityGuard
      LoaderComponent={<AppLoading message="Validando a confiabilidade da sessão..." />}
    >
      <MigrationGuard>
        <ProtectedPageProviders>
          <PageView>
            <PrivateRouteLayout>
              <Outlet />
            </PrivateRouteLayout>
          </PageView>
        </ProtectedPageProviders>
      </MigrationGuard>
    </SessionReliabilityGuard>
  )
}
